import { Tooltip } from "antd";
import styled from "styled-components";
import { useTranslate } from "@refinedev/core";

/**
 * "What's a playbook?" hint shown as the Playbooks page description: a
 * design-system link (primary color, underlined) that explains playbooks in a
 * tooltip, on hover and on keyboard focus.
 */
export const PlaybookHint = () => {
  const t = useTranslate();
  return (
    <Tooltip
      placement="bottom"
      trigger={["hover", "focus"]}
      title={t("pages.playbooks.tooltip.title")}
    >
      <StyledHint tabIndex={0}>{t("pages.playbooks.tooltip.text")}</StyledHint>
    </Tooltip>
  );
};

// ─── Styled components ───

const StyledHint = styled.span`
  color: ${({ theme }) => theme.colorPrimary};
  text-decoration: underline;
  text-underline-offset: ${({ theme }) => theme.lineWidthBold}px;
  cursor: help;

  &:hover {
    color: ${({ theme }) => theme.colorPrimaryHover};
  }

  &:focus-visible {
    outline: ${({ theme }) =>
      `${theme.lineWidthBold}px solid ${theme.colorPrimary}`};
    outline-offset: ${({ theme }) => theme.lineWidthBold}px;
    border-radius: ${({ theme }) => theme.borderRadiusSM}px;
  }
`;
